import React from 'react';
import useV2LazyQuery from 'utils/useV2LazyQuery';
import { GET_REFRESHED_LEDGER_BALANCE } from 'general-ledger/fast-gl/graphql/queries';
import { Button } from 'bench-internal-theme';
import { LedgerAccount } from 'general-ledger/fast-gl/types';
import { useGeneralLedger } from 'general-ledger/fast-gl/hooks/useGeneralLedger';

type BalanceRefreshButtonProps = {
  ledgerAccount: LedgerAccount;
};

export const BalanceRefreshButton = ({
  ledgerAccount,
}: BalanceRefreshButtonProps): React.ReactElement => {
  const { dateRange } = useGeneralLedger();
  const [updateBalance, { loading }] = useV2LazyQuery(GET_REFRESHED_LEDGER_BALANCE, {
    variables: {
      ledgerId: ledgerAccount.id,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    },
    fetchPolicy: 'cache-and-network',
  });

  const handleRefreshButtonClick = () => {
    updateBalance();
  };

  return (
    <Button
      icon="refresh"
      size="xsmall"
      styleType="total-ghost"
      title="Refresh balance"
      onClick={handleRefreshButtonClick}
      disabled={loading}
    />
  );
};
